import { settings } from "@alme/ui-web/settings/settings-util";
//@ts-ignore
import * as postMessageUtilities from "@alme/ui-web/modules/lib-postmessage/lib/lib-postmessage";
//@ts-ignore
import { AlmeState } from "@alme/ui-web/wireup/AlmeState";
import { Store } from "redux";
import * as Actions from "./actions/actions";
import * as Reducers from "./reducers/index";

/**
 * Responsible for processing the changeLocale message
 * received from the ClientCommunicator. It also removes the message after it is processed.
 */
export default class ChangeLocaleProcessor
{
  _settings: typeof settings;
  _store: Store<AlmeState> | undefined;
  constructor(passedSettings: typeof settings) {
    this._settings = passedSettings || settings;
  }

  initialize(store: Store<AlmeState>) {
    this._store = store;

    postMessageUtilities.setupStateWatchForReceivedMessages(
      this._settings,
      this._store,
      this.processLocale.bind(this)
    );
  }

  static getDefaultSettings() {
    return settings;
  }

  getReducer() {
    return Reducers.reducer;
  }

  processLocale(newVal: any) {
    const msg = postMessageUtilities.getAndValidateMessage(
      newVal,
      "localechange"
    );
    if (msg === null) {
      return;
    }
    if (this._store) {
      let locale = "";
      if (msg.message && msg.message.Data && msg.message.Data.locale) {
        locale = msg.message.Data.locale;
      }
      
      if(locale === null || locale === "")
      {
        console.warn("Value for locale was empty or not found. Please supply a valid language code.");
        return;
      }

      const base = this._settings.stateLocations.Conversation.Base;
      const location = this._settings.stateLocations.Conversation.language;
      const stateLocation = `${base}.${location}`;            
      locale = locale.replace('_', '-');
      this._store.dispatch(Actions.updateLocale({ stateLocation, locale }));
    }
  }
}



// WEBPACK FOOTER //
// ./modules/process-locale-post/changeLocaleProcessor.ts